export default [
  {
    path: '/home',
    name: 'home',
    component: () => import('@/pages/naiyun202609/home'),
    meta: {
      title: '首页',
    }
  },
  {
    path: '/productService',
    name: 'productService',
    // 给父组件起名为 product-layout
    component: () => import(/* webpackChunkName: "product-layout" */ '@/pages2.0/productService/index.vue'),
    redirect: '/productService/software',
    meta: {
      title: '产品服务',
      message: '原创技术成就业务及服务',
      backgroundImg: '产品服务.jpg'
    },
    children: [
      {
        path: '/productService/software',
        name: 'softwareProduct',
        component: () => import('@/pages2.0/productService/software.vue'),
        meta: { title: '软件产品' },
      },
      {
        path: '/productService/hardwareProduct',
        name: 'hardwareProduct',
        component: () => import('@/pages2.0/productService/hardwareProduct.vue'),
        meta: { title: '硬件产品' },
      },
      {
        path: '/productService/deepService',
        name: 'deepService',
        component: () => import('@/pages2.0/productService/deepService.vue'),
        meta: { title: '深度定制服务' },
      },
    ]
  },
  // {
  //   path: '/industryApplicationHome',
  //   name: 'industryApplicationHome',
  //   component: () => import('@/pages3.0/industryApplication'), // 行业应用首页组件
  //   meta: {
  //     title: '行业应用', // 与菜单标题一致
  //     message: '实时监测全网舆情，大数据激发智慧商机',
  //     backgroundImg: 'intelligentEmergency.png'
  //   }
  // },
  {
    path: '/industryApplication',
    name: 'industryApplication',
    component: () => import('@/pages3.0/industryApplication'),
    meta: {
      title: '行业应用',
      message: '实时监测全网舆情，大数据激发智慧商机',
      backgroundImg: 'intelligentEmergency.png'
    },
    children: [
      {
        path: '/industryApplication#panel-enterprise',
        name: 'smartPower',
        meta: { title: '企业智改数转赋能应用' },
      },

      {
        path: '/industryApplication#panel-chemical',
        name: 'smartFactory',
        meta: { title: '化工园区安全生产监管平台' },
      },
      {
        path: '/industryApplication#panel-smart-park',
        name: 'smartPark',
        meta: { title: '智慧园区综合服务应用' },
      },

      {
        path: '/industryApplication#panel-digital-twin',
        name: 'intelligentEmergency',
        meta: { title: '数字孪生构建泛应用', },
      },
      {
        path: '/industryApplication#panel-city',
        name: 'smartCity',
        meta: { title: '城市综合服务与应急管理' },
      },
    ]
  },

  {
    path: '/aboutUs',
    name: 'aboutUs',
    component: () => import('@/pages2.0/aboutUs'),
    meta: {
      title: '关于我们',
      message: '独立研发的数据分析系统 | 携手企业走向数字化转型',
      backgroundImg: '关于我们.jpg'
    },
  },

]



// WEBPACK FOOTER //
// ./src/router/module3.0.js